.gallery {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  padding: 16px;
  list-style: none;
  margin: 0;
}